import React from 'react';
import styled, { css } from 'styled-components';

import type { SelectOption } from '@rover/types/src/SelectOption';

import type { Props as DropdownProps } from '../Dropdown/Dropdown';
import Dropdown, { Button, Menu, MenuOption } from '../Dropdown/Dropdown';
import { DropdownState } from '../Dropdown/Dropdown.constants';

import IconOption from './IconOption';
import IconSelectArrow from './IconSelectArrow';

export type Props = Omit<DropdownProps, 'options'> & {
  value: string;
  options: SelectOption[];
  listMaxHeight?: string;
};
const StyledDropdown = styled(Dropdown)<DropdownProps & { listMaxHeight?: string }>`
  &.${DropdownState.OPEN.toString()} {
    ${Button} {
      background-color: ${({ theme }) => theme.background.primary};
    }
  }

  ${Button} {
    cursor: pointer;
    padding: ${({ theme }) => theme.space['1x']};
    box-shadow: ${({ theme }) =>
      `inset 0 0 0 ${theme.borderWidth.primary} ${theme.colors.border.primary}`};
    border-radius: ${({ theme }) => theme.radii.secondary};

    &:hover {
      background-color: ${({ theme }) => theme.background.secondary};
    }
  }

  ${Menu} {
    margin-top: 1px;
    padding: 0;
    width: 100%;

    border: 0;
    border-radius: ${({ theme }) => theme.radii.secondary};
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);

    ${({ listMaxHeight }) =>
      listMaxHeight &&
      css`
        max-height: ${listMaxHeight};
        overflow-y: scroll;
      `}
  }

  ${MenuOption} {
    padding: 0;

    &.${DropdownState.FOCUSED_OPTION.toString()}, &.${DropdownState.SELECTED_OPTION.toString()} {
      background-color: ${({ theme }) => theme.background.tertiary};
    }
  }
`;

const IconSelect = ({ options, ...props }: Props): JSX.Element => {
  const formatOptions = options.map((option) => ({
    value: option.value,
    label: <IconOption data={option} />,
  }));
  return <StyledDropdown {...props} arrow={IconSelectArrow} options={formatOptions} />;
};

export default IconSelect;
